export const MENU_ITEM_NAMES = 'menuItemNames';
export const HEADER = 'header';
export const ITEM_DESCRIPTION_AND_PRICES = 'itemDescriptionsAndPrices';
export const MENU_SECTION_TITLES = 'menuSectionTitles';
